import { MessageCircle } from "lucide-react";

const WhatsAppFloat = () => {
  return (
    <a
      href="https://wa.me/16789865476?text=Hello%20Spiruva%2C%20I%27m%20interested%20in%20your%20phycocyanin%20catalogue."
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      className="fixed bottom-24 right-5 z-40 flex items-center gap-2 bg-brand-teal text-brand-cream pl-3 pr-4 py-3 shadow-lg shadow-brand-teal/20 hover:bg-brand-green transition-all duration-300 group"
      aria-label="WhatsApp Business"
    >
      <MessageCircle size={18} />
      <span className="text-xs uppercase tracking-widest hidden md:inline">WhatsApp</span>
      <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-brand-gold rounded-full animate-pulse" />
    </a>
  );
};

export default WhatsAppFloat;
